module.exports = __webpack_public_path__ + "static/media/UIET.2dc2edfb.png";